import { createContext } from 'react';

const { Consumer, Provider } = createContext([]);

export { Provider as SectionSlugsProvider, Consumer as SectionSlugsConsumer };
